/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ToastMessageOptions } from 'primeng/api';
import { ErrorService } from '@irian-ro/shared-components-module';
import { ActionAddPageService } from './action-add-page.service';
import { takeUntil } from 'rxjs/operators';
import { ActionDefinitionDtoMetaDataModel, ActionDefinitionDtoModel } from '@well/domain';

@Component({
  selector: 'well-action-add-page',
  templateUrl: './action-add-page.component.html',
  styleUrls: ['./action-add-page.component.scss']
})
export class ActionAddPageComponent implements OnInit, OnDestroy {

  action: ActionDefinitionDtoModel | null = null;

  @Input() subscriptionTypeUuid: string | undefined = undefined;

  actionUuid: string | null = null;

  msg: Observable<ToastMessageOptions[]> | undefined = undefined;

  @Output() saveSuccess: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancelOperation: EventEmitter<void> = new EventEmitter<void>();

  destroy: Subject<boolean> = new Subject<boolean>();

  meta: ActionDefinitionDtoMetaDataModel | undefined = undefined;

  constructor(private actionAddPageService: ActionAddPageService,
              private errorService: ErrorService) {
  }

  ngOnInit() {
    if (this.subscriptionTypeUuid) {

      this.actionAddPageService.getTemplate(this.subscriptionTypeUuid)
        .pipe(takeUntil(this.destroy))
        .subscribe(res => {
          this.action = res.data;
          this.meta = res.meta;
        });
    }
  }

  onActionSubmit(action: any) {
    this.actionAddPageService.save(action)
      .subscribe(
        data => {
          this.actionUuid = data.uuid;
          this.saveSuccess.next(true);
        },
        error => {
          this.msg = this.errorService.prepareErrorsForDisplay(error, 'company.actions.errors');
        }
      );
  }

  goBack() {
    this.cancelOperation.next();
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
  }

}
